export default __webpack_public_path__ + "static/media/EdenOvadia.3c6f341d.png";